import axios from "axios";

// 2026-08-05 — production-readiness audit: REACT_APP_BACKEND_URL used to
// be read with no fallback, in ~20 different files, each with its own
// (usually absent) safety net. CRA bakes REACT_APP_* vars in at build
// time, so a deploy that forgets to set this doesn't error — it just
// silently ships a build where every API call goes to "undefined/api/...".
// Centralized here as BACKEND_URL so every file that needs the raw base
// URL (not going through the `api` axios instance below) imports this
// instead of reading process.env directly — one place to fix, and a
// loud console warning instead of a silent break.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
if (!BACKEND_URL && typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.warn(
    "[config] REACT_APP_BACKEND_URL is not set — API calls will fail. " +
    "Set it in your .env (see .env.example) or your deploy environment."
  );
}
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ── 402 Payment Required interceptor ─────────────────────────────
// When the backend blocks an action because the tenant has no active
// subscription (trial expired, past_due_locked, canceled, inactive),
// it returns 402 with a structured detail. We display a single toast +
// redirect to /dashboard/billing so the OWNER can subscribe immediately.
let _redirecting402 = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && !_redirecting402) {
      const detail = err.response.data?.detail;
      const msg = (detail && typeof detail === "object" && detail.message) ||
                  "Abonnement requis pour cette action.";
      // Lazy-import to avoid circular dep with sonner
      import("sonner").then(({ toast }) => toast.error(msg));
      if (typeof window !== "undefined" &&
          !window.location.pathname.startsWith("/dashboard/billing")) {
        _redirecting402 = true;
        setTimeout(() => { window.location.href = "/dashboard/billing"; _redirecting402 = false; }, 800);
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" — ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
